import React from "react";
import themes from "./themes";

export default React.createContext(themes.OPTUM);
